<template>
  <div class="page-profile__content site-width">
    <header class="page-profile__header">
      <h1 class="page-profile__title text-h3">
        {{ $t('Profile') }}
      </h1>
      <user-card
        :username="user.username"
        :email="user.email"
      />
    </header>

    <div class="page-profile__change text-center">
      <div class="page-profile__change__item">
        <a
          @click.prevent="showEmailForm = true"
          v-if="!showEmailForm"
          href="#"
        >{{ $t('Change Email') }}</a>
        <form-update-email
          @submit="onFormUpdateEmailSubmit"
          @cancel="showEmailForm = false"
          v-if="showEmailForm"
          :loading="isEmailProcessing"
          class="form form-update"
        />
      </div>

      <div class="page-profile__change__item">
        <a
          @click.prevent="showPasswordForm = true"
          v-if="!showPasswordForm"
          href="#"
        >{{ $t('Change Password') }}</a>
        <form-update-password
          @submit="onFormUpdatePasswordSubmit"
          @cancel="showPasswordForm = false"
          v-if="showPasswordForm"
          :loading="isPasswordProcessing"
          class="form form-update"
        />
      </div>
      <div class="page-profile__change__item">
        <a
          @click.prevent="showUsernameForm = true"
          v-if="!showUsernameForm"
          href="#"
        >{{ $t('Change Username') }}</a>
        <form-update-username
          @submit="onFormUpdateUsernameSubmit"
          @cancel="showUsernameForm = false"
          v-if="showUsernameForm"
          :loading="isUsernameProcessing"
          class="form form-update"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { capitalize } from 'lodash';

import { mapGetters, mapActions } from 'vuex';
import UserCard from '@/components/common/UserCard';
import FormUpdateUsername from '@/components/forms/FormUpdateUsername';
import FormUpdateEmail from '@/components/forms/FormUpdateEmail';
import FormUpdatePassword from '@/components/forms/FormUpdatePassword';

@Component({
  name: 'page-profile',
  components: {
    UserCard,
    FormUpdateUsername,
    FormUpdateEmail,
    FormUpdatePassword,
  },
  computed: mapGetters(['user']),
  watch: {
    '$route.query': function({ edit, section }) {
      this.showEmailForm = false;
      this.showUsernameForm = false;
      this.showPasswordForm = false;
      if (!edit || !section) return;
      this[`show${capitalize(section)}Form`] = true;
    },
  },
  methods: mapActions(['updateProfileField', 'setUserData']),
})
export default class PageProfile extends Vue {
  showEmailForm = false;
  showUsernameForm = false;
  showPasswordForm = false;

  isEmailProcessing = false;
  isUsernameProcessing = false;
  isPasswordProcessing = false;

  created() {
    this.init();
  }

  init() {
    this.initEditSection();
  }

  initEditSection() {
    if (this.$route.query.edit) {
      this[`show${capitalize(this.$route.query.section)}Form`] = true;
    }
  }

  async onFormUpdateUsernameSubmit(data) {
    this.isUsernameProcessing = true;
    try {
      const result = await this.updateProfileField({
        field: 'username',
        data,
      });
      this.setUserData(result);
      this.showUsernameForm = false;
    } catch (error) {
      console.error(error);
    }
    this.isUsernameProcessing = false;
  }

  async onFormUpdateEmailSubmit(data) {
    this.isEmailProcessing = true;
    try {
      const result = await this.updateProfileField({
        field: 'email',
        data,
      });

      const { token, user } = result;

      this.$api.User.setToken(token);
      this.$ls.set('token', token);
      this.$ls.set('user', user);
      this.setUserData(user);
      this.showEmailForm = false;
    } catch (error) {
      console.error(error);
    }
    this.isEmailProcessing = false;
  }

  async onFormUpdatePasswordSubmit(data) {
    this.isPasswordProcessing = true;
    try {
      await this.updateProfileField({
        field: 'password',
        data,
      });
      this.showPasswordForm = false;
    } catch (error) {
      console.error(error);
    }
    this.isPasswordProcessing = false;
  }
}
</script>
<style lang="scss">
.page-profile {
  &__content {
  }
  &__header {
    padding: 10px;
    padding: 3vh 3vh 3vh calc(6vh + (15px * 2) + 40px);
    & > * + * {
      margin-top: 10px;
    }
    & + * {
      margin-top: 20px;
    }
  }
  &__change {
    &__item + * {
      margin-top: 1em;
    }
    &__item {
      & > * + * {
        margin-top: 1em;
      }
      .form {
        padding-bottom: 20px;
        padding: 20px 0;
        border: solid rgba($clr-black, 0.1);
        border-width: 3px 0;
      }
    }
  }
}
</style>
